<ng-template #icon>
    @if (showIcon) {
        <fa-icon [icon]="iconExclamation" class="me-1"></fa-icon>
    }
</ng-template>

@if (control.invalid && (control.dirty || control.touched || submitted)) {
    <div class="validation-component">
        @if (customValidationText) {
            <div>
                <ng-container *ngTemplateOutlet="icon"></ng-container>{{ customValidationText }}
            </div>
        } @else {
            @if (control.errors?.['pattern']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.Pattern }} '{{ control.errors.pattern.requiredPattern }}'
                </div>
            }
            @if (control.errors?.['min']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.Min }} {{ control.errors.min.min }}
                </div>
            }
            @if (control.errors?.['max']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.Max }} {{ control.errors.max.max }}
                </div>
            }
            @if (control.errors?.['required']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.Required }}
                </div>
            }
            @if (control.errors?.['minlength']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.MinlengthStart }} {{ control.errors.minlength.requiredLength }} {{ validationText.LengthEnd }}
                </div>
            }
            @if (control.errors?.['maxlength']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.MaxlengthStart }} {{ control.errors.maxlength.requiredLength }} {{ validationText.LengthEnd }}
                </div>
            }
            @if (control.errors?.['email']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.Email }}
                </div>
            }
            @if (control.errors?.['emailDelimited']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.EmailDelimited }} {{ emailDelimitedText(control.errors?.emailDelimited?.separator)}}
                </div>
            }
            @if (control.errors?.['requiredTrue']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.RequiredTrue }}
                </div>
            }
            @if (control.errors?.['invalidPasswordLength']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.MinlengthStart }} {{ control.errors.invalidPasswordLength.requiredLength }} {{ validationText.LengthEnd }}
                </div>
            }
            @if (control.errors?.['invalidPasswordChars']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ control.errors.invalidPasswordChars.required }}
                </div>
            }
            @if (control.errors?.['invalidBlobSize']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.invalidBlobSize.message }}
                </div>
            }
            @if (control.errors?.['invalidJson']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.invalidJson.message }}
                </div>
            }
            @if (control.errors?.['requiredCheckboxOrRadioToBeChecked']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.requiredCheckboxOrRadioToBeChecked.message }}
                </div>
            }
            @if (control.errors?.['endBeforeStartDate']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.endBeforeStartDate.message }}
                </div>
            }
            @if (control.errors?.['pastDate']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.pastDate.message }}
                </div>
            }
            @if (control.errors?.['minDate']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.minDate.message }}
                </div>
            }
            @if (control.errors?.['maxDateWindow']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.maxDateWindow.message }}
                </div>
            }
            @if (control.errors?.['minMaxValidation']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.minMaxValidation.message }}
                </div>
            }
            @if (control.errors?.['invalidFileType']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.invalidFileType.message }}
                </div>
            }
            @if (control.errors?.['optionsUnavailable']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.optionsUnavailable.message }}
                </div>
            }
            @if (control.errors?.['currentPasswordMatchesNew']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.currentPasswordMatchesNew.message }}
                </div>
            }
            @if (control.errors?.['confirmPasswordNotMatchesNew']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.confirmPasswordNotMatchesNew.message }}
                </div>
            }
            @if (control.errors?.['username']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.username.message }}
                </div>
            }
            @if (control.errors?.['invalidEmails']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.invalidEmails.length }} {{ control.errors.invalidEmails.length > 1 ? validationText.EmailList :  validationText.EmailListSingular }}
                </div>
            }
            @if (control.errors?.['scheduleFields']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.scheduleFields.message }}
                </div>
            }
            @if (control.errors?.['atLeastOneRequired']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.atLeastOneRequired.message }}
                </div>
            }
            @if (control.errors?.['cloneSourceRequired']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.cloneSourceRequired.message }}
                </div>
            }
            @if (control.errors?.['noShopifyDomain']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.noShopifyDomain.message }}
                </div>
            }
            @if (control.errors?.['nonWhitespace']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.nonWhitespace.message }}
                </div>
            }
            @if (control.errors?.['url']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ labelText }} {{ validationText.Url }}
                </div>
            }
            @if (control.errors?.['fileNameCompressionMismatch']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.fileNameCompressionMismatch.message }}
                </div>
            }
            @if (control.errors?.['retriesProduct']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.retriesProduct.message }}
                </div>
            }
            @if (control.errors?.['webhookUrl']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.webhookUrl.message }}
                </div>
            }
            @if (control.errors?.['ndjsonHeaderFooter']) {
                <div>
                    <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.ndjsonHeaderFooter.message }}
                </div>
            }
            @if (control.errors?.['invalidFqlQuery']) {
                @if (control.errors.invalidFqlQuery.invalidFields?.length > 0) {
                    <div>
                        <ng-container *ngTemplateOutlet="icon"></ng-container>
                        @for (segment of fqlFieldNameSegments(control.errors.invalidFqlQuery.invalidFields); track segment.name) {
                            <span class="fw-bold font-monospace text-primary">{{ segment.name }}</span>{{ segment.separator }}
                        }
                        {{ control.errors.invalidFqlQuery.invalidFields.length > 1 ? validationText.InvalidFqlFields : validationText.InvalidFqlFieldsSingular }}
                    </div>
                } @else {
                    <div>
                        <ng-container *ngTemplateOutlet="icon"></ng-container>{{ control.errors.invalidFqlQuery.message }}
                    </div>
                }
            }
        }
    </div>
}
